// global settings actions

export const GET_PAGE_ITEM_OPERATIONS = 'GET_PAGE_ITEM_OPERATIONS';
export const GET_PAGE_ITEM_OPERATIONS_SUCCESS =
  'GET_PAGE_ITEM_OPERATIONS_SUCCESS';
export const GET_PAGE_ITEM_OPERATIONS_FAIL = 'GET_PAGE_ITEM_OPERATIONS_FAIL';

export const GET_ALERT_LISTING_COLUMN_NAMES = 'GET_ALERT_LISTING_COLUMN_NAMES';
export const GET_ALERT_LISTING_COLUMN_NAMES_SUCCESS =
  'GET_ALERT_LISTING_COLUMN_NAMES_SUCCESS';
export const GET_ALERT_LISTING_COLUMN_NAMES_FAIL =
  'GET_ALERT_LISTING_COLUMN_NAMES_FAIL';

export const GET_ALERT_DETAILS_COLUMN_NAMES = 'GET_ALERT_DETAILS_COLUMN_NAMES';
export const GET_ALERT_DETAILS_COLUMN_NAMES_SUCCESS =
  'GET_ALERT_DETAILS_COLUMN_NAMES_SUCCESS';
export const GET_ALERT_DETAILS_COLUMN_NAMES_FAIL =
  'GET_ALERT_DETAILS_COLUMN_NAMES_FAIL';

export const GET_TM_ALERTS_LISTING_SETTINGS = 'GET_TM_ALERTS_LISTING_SETTINGS';
export const GET_TM_ALERTS_LISTING_SETTINGS_SUCCESS =
  'GET_TM_ALERTS_LISTING_SETTINGS_SUCCESS';
export const GET_TM_ALERTS_LISTING_SETTINGS_FAIL =
  'GET_TM_ALERTS_LISTING_SETTINGS_FAIL';

export const PUT_TM_ALERTS_LISTING_SETTINGS = 'PUT_TM_ALERTS_LISTING_SETTINGS';
export const PUT_TM_ALERTS_LISTING_SETTINGS_SUCCESS =
  'PUT_TM_ALERTS_LISTING_SETTINGS_SUCCESS';
export const PUT_TM_ALERTS_LISTING_SETTINGS_FAIL =
  'PUT_TM_ALERTS_LISTING_SETTINGS_FAIL';

export const GET_GLOBAL_SETTINGS_PAGE_INFO = 'GET_GLOBAL_SETTINGS_PAGE_INFO';
export const GET_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS =
  'GET_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS';
export const GET_GLOBAL_SETTINGS_PAGE_INFO_FAIL =
  'GET_GLOBAL_SETTINGS_PAGE_INFO_FAIL';

export const GET_NS_GLOBAL_SETTINGS_PAGE_INFO =
  'GET_NS_GLOBAL_SETTINGS_PAGE_INFO';
export const GET_NS_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS =
  'GET_NS_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS';
export const GET_NS_GLOBAL_SETTINGS_PAGE_INFO_FAIL =
  'GET_NS_GLOBAL_SETTINGS_PAGE_INFO_FAIL';

export const PUT_GLOBAL_SETTINGS_WIDGET_GROUP =
  'PUT_GLOBAL_SETTINGS_WIDGET_GROUP';
export const PUT_GLOBAL_SETTINGS_WIDGET_GROUP_SUCCESS =
  'PUT_GLOBAL_SETTINGS_WIDGET_GROUP_SUCCESS';
export const PUT_GLOBAL_SETTINGS_WIDGET_GROUP_FAIL =
  'PUT_GLOBAL_SETTINGS_WIDGET_GROUP_FAIL';

export const PUT_GLOBAL_SETTINGS_WIDGETS = 'PUT_GLOBAL_SETTINGS_WIDGETS';
export const PUT_GLOBAL_SETTINGS_WIDGETS_SUCCESS =
  'PUT_GLOBAL_SETTINGS_WIDGETS_SUCCESS';
export const PUT_GLOBAL_SETTINGS_WIDGETS_FAIL =
  'PUT_GLOBAL_SETTINGS_WIDGETS_FAIL';

export const PUT_GLOBAL_SETTINGS_WIDGET_INFO =
  'PUT_GLOBAL_SETTINGS_WIDGET_INFO';
export const PUT_GLOBAL_SETTINGS_WIDGET_INFO_SUCCESS =
  'PUT_GLOBAL_SETTINGS_WIDGET_INFO_SUCCESS';
export const PUT_GLOBAL_SETTINGS_WIDGET_INFO_FAIL =
  'PUT_GLOBAL_SETTINGS_WIDGET_INFO_FAIL';

export const GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO =
  'GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO';
export const GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS =
  'GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS';
export const GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_FAIL =
  'GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_FAIL';

// create run instance actions

export const GET_CATEGORIES_CREATE_RUN_INSTANCE =
  'GET_CATEGORIES_CREATE_RUN_INSTANCE';
export const GET_CATEGORIES_CREATE_RUN_INSTANCE_SUCCESS =
  'GET_CATEGORIES_CREATE_RUN_INSTANCE_SUCCESS';
export const GET_CATEGORIES_CREATE_RUN_INSTANCE_FAIL =
  'GET_CATEGORIES_CREATE_RUN_INSTANCE_FAIL';

export const POST_SEGMENT_SETS_RUN_INSTANCE = 'POST_SEGMENT_SETS_RUN_INSTANCE';
export const POST_SEGMENT_SETS_RUN_INSTANCE_SUCCESS =
  'POST_SEGMENT_SETS_RUN_INSTANCE_SUCCESS';
export const POST_SEGMENT_SETS_RUN_INSTANCE_FAIL =
  'POST_SEGMENT_SETS_RUN_INSTANCE_FAIL';

export const GET_LIVE_SETS_RUN_INSTANCE = 'GET_LIVE_SETS_RUN_INSTANCE';
export const GET_LIVE_SETS_RUN_INSTANCE_SUCCESS =
  'GET_LIVE_SETS_RUN_INSTANCE_SUCCESS';
export const GET_LIVE_SETS_RUN_INSTANCE_FAIL =
  'GET_LIVE_SETS_RUN_INSTANCE_FAIL';

// create run instance actions

export function getCategories(payload) {
  return {
    type: GET_CATEGORIES_CREATE_RUN_INSTANCE,
    payload
  };
}

export function getCategoriesSuccess(payload) {
  return {
    type: GET_CATEGORIES_CREATE_RUN_INSTANCE_SUCCESS,
    payload
  };
}

export function getCategoriesFail(payload) {
  return {
    type: GET_CATEGORIES_CREATE_RUN_INSTANCE_FAIL,
    payload
  };
}

export function postSegmentSets(payload) {
  return {
    type: POST_SEGMENT_SETS_RUN_INSTANCE,
    payload
  };
}

export function postSegmentSetsSuccess(payload) {
  return {
    type: POST_SEGMENT_SETS_RUN_INSTANCE_SUCCESS,
    payload
  };
}

export function postSegmentSetsFail(payload) {
  return {
    type: POST_SEGMENT_SETS_RUN_INSTANCE_FAIL,
    payload
  };
}

export function getLiveSets(payload) {
  return {
    type: GET_LIVE_SETS_RUN_INSTANCE,
    payload
  };
}

export function getLiveSetsSuccess(payload) {
  return {
    type: GET_LIVE_SETS_RUN_INSTANCE_SUCCESS,
    payload
  };
}

export function getLiveSetsFail(payload) {
  return {
    type: GET_LIVE_SETS_RUN_INSTANCE_FAIL,
    payload
  };
}

// global settings actions

export function getPageItemOperations(payload) {
  return {
    type: GET_PAGE_ITEM_OPERATIONS,
    payload
  };
}

export function getPageItemOperationsSuccess(payload) {
  return {
    type: GET_PAGE_ITEM_OPERATIONS_SUCCESS,
    payload
  };
}

export function getPageItemOperationsFail(payload) {
  return {
    type: GET_PAGE_ITEM_OPERATIONS_FAIL,
    payload
  };
}

export function getAlertListingColumnNames() {
  return {
    type: GET_ALERT_LISTING_COLUMN_NAMES
  };
}

export function getAlertListingColumnNamesSuccess(payload) {
  return {
    type: GET_ALERT_LISTING_COLUMN_NAMES_SUCCESS,
    payload
  };
}

export function getAlertListingColumnNamesFail(payload) {
  return {
    type: GET_ALERT_LISTING_COLUMN_NAMES_FAIL,
    payload
  };
}

export function getAlertDetailsColumnNames(payload) {
  return {
    type: GET_ALERT_DETAILS_COLUMN_NAMES,
    payload
  };
}

export function getAlertDetailsColumnNamesSuccess(payload) {
  return {
    type: GET_ALERT_DETAILS_COLUMN_NAMES_SUCCESS,
    payload
  };
}

export function getAlertDetailsColumnNamesFail(payload) {
  return {
    type: GET_ALERT_DETAILS_COLUMN_NAMES_FAIL,
    payload
  };
}

export function getTMAlertsListingSettings(payload) {
  return {
    type: GET_TM_ALERTS_LISTING_SETTINGS,
    payload
  };
}

export function getTMAlertsListingSettingsSuccess(payload) {
  return {
    type: GET_TM_ALERTS_LISTING_SETTINGS_SUCCESS,
    payload
  };
}

export function getTMAlertsListingSettingsFail(payload) {
  return {
    type: GET_TM_ALERTS_LISTING_SETTINGS_FAIL,
    payload
  };
}

export function putTMAlertsListingSettings(payload) {
  return {
    type: PUT_TM_ALERTS_LISTING_SETTINGS,
    payload
  };
}

export function putTMAlertsListingSettingsSuccess(payload) {
  return {
    type: PUT_TM_ALERTS_LISTING_SETTINGS_SUCCESS,
    payload
  };
}

export function putTMAlertsListingSettingsFail(payload) {
  return {
    type: PUT_TM_ALERTS_LISTING_SETTINGS_FAIL,
    payload
  };
}

// phase 3
export function getGlobalSettingsPageInfo(payload) {
  return {
    type: GET_GLOBAL_SETTINGS_PAGE_INFO,
    payload
  };
}

export function getGlobalSettingsPageInfoSuccess(payload) {
  return {
    type: GET_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS,
    payload
  };
}

export function getGlobalSettingsPageInfoFail(payload) {
  return {
    type: GET_GLOBAL_SETTINGS_PAGE_INFO_FAIL,
    payload
  };
}

export function putGlobalSettingsWidgetGroup(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGET_GROUP,
    payload
  };
}

export function putGlobalSettingsWidgetGroupSuccess(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGET_GROUP_SUCCESS,
    payload
  };
}

export function putGlobalSettingsWidgetGroupFail(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGET_GROUP_FAIL,
    payload
  };
}

export function putGlobalSettingsWidgets(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGETS,
    payload
  };
}

export function putGlobalSettingsWidgetsSuccess(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGETS_SUCCESS,
    payload
  };
}

export function putGlobalSettingsWidgetsFail(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGETS_FAIL,
    payload
  };
}

export function putGlobalSettingsWidgetInfo(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGET_INFO,
    payload
  };
}

export function putGlobalSettingsWidgetInfoSuccess(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGET_INFO_SUCCESS,
    payload
  };
}

export function putGlobalSettingsWidgetInfoFail(payload) {
  return {
    type: PUT_GLOBAL_SETTINGS_WIDGET_INFO_FAIL,
    payload
  };
}

export function getNSGlobalSettingsPageInfo(payload) {
  return {
    type: GET_NS_GLOBAL_SETTINGS_PAGE_INFO,
    payload
  };
}

export function getNSGlobalSettingsPageInfoSuccess(payload) {
  return {
    type: GET_NS_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS,
    payload
  };
}

export function getNSGlobalSettingsPageInfoFail(payload) {
  return {
    type: GET_NS_GLOBAL_SETTINGS_PAGE_INFO_FAIL,
    payload
  };
}

export function getAMLSCommonGlobalSettingsPageInfo(payload) {
  return {
    type: GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO,
    payload
  };
}

export function getAMLSCommonGlobalSettingsPageInfoSuccess(payload) {
  return {
    type: GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_SUCCESS,
    payload
  };
}

export function getAMLSCommonGlobalSettingsPageInfoFail(payload) {
  return {
    type: GET_AMLS_COMMON_GLOBAL_SETTINGS_PAGE_INFO_FAIL,
    payload
  };
}
